import React from 'react'
import { Col, Container, Row, Table } from "reactstrap";
import TabletGestionDocumentos from './TabletGestionDocumentos';

export function GdGestionDocumentos() {
  return (
     <Container className="dashboard">
      <Row>
        <Col md={12}>
            <h3 style={{ marginBottom: 30, color:"#024b82" }}>Consulta de documentos</h3>
        </Col>
      </Row>
      <Row>
        <TabletGestionDocumentos/>
      </Row>
    </Container>
  )
}
